import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { RiRobot2Line } from '@remixicon/react';
import { analyticsDoPortal } from './analytics';
import { rotaObservabilidadeIa } from './routes';

const paginaObservabilidade = PageBlueprint.make({
  name: 'observabilidade-ia',
  params: {
    routeRef: rotaObservabilidadeIa,
    path: '/observabilidade-ia',
    title: 'Observabilidade de IA',
    icon: <RiRobot2Line />,
    loader: () =>
      import('./components/ObservabilidadeIa').then(m => <m.ObservabilidadeIa />),
  },
});

export const entregaPlugin = createFrontendPlugin({
  pluginId: 'entrega',
  extensions: [paginaObservabilidade, analyticsDoPortal],
  routes: { observabilidadeIa: rotaObservabilidadeIa },
});
